module.exports = __webpack_public_path__ + "img/background-logo.ec4071bd.svg";